import { useEffect, useState } from "react";
import axios from "axios";
import { Spinner } from "@heroui/spinner";

export default function RatiosTab({ stockSymbol }) {
  // Initialize state variables for stock data
  const [peRatioTTM, setPeRatioTTM] = useState();
  const [grossProfitMarginTTM, setGrossProfitMarginTTM] = useState();
  const [netProfitMarginTTM, setNetProfitMarginTTM] = useState();
  const [returnOnEquityTTM, setReturnOnEquityTTM] = useState();
  const [totalDebtToCapitalizationTTM, setTotalDebtToCapitalizationTTM] =
    useState();
  const [interestCoverageTTM, setInterestCoverageTTM] = useState();
  const [symbol, setSymbol] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchStockData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(
          "/api/company/ratios",
          { ticker: stockSymbol },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data && response.data.length > 0) {
          const data = await response.data;
          const stockInfo = data[0];
          setSymbol(stockInfo.symbol);
          setPeRatioTTM(Number(stockInfo.peRatioTTM).toFixed(2));
          setGrossProfitMarginTTM(
            Number(stockInfo.grossProfitMarginTTM).toFixed(2)
          );
          setNetProfitMarginTTM(Number(stockInfo.netProfitMarginTTM).toFixed(2));
          setReturnOnEquityTTM(Number(stockInfo.returnOnEquityTTM).toFixed(2));
          setTotalDebtToCapitalizationTTM(
            Number(stockInfo.totalDebtToCapitalizationTTM).toFixed(2)
          );
          setInterestCoverageTTM(
            Number(stockInfo.interestCoverageTTM).toFixed(2)
          );
        }

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error fetching stock data:", error);
      }
    };

    fetchStockData();
  }, [stockSymbol]);

  // Loading condition
  if (
    isLoading &&
    !peRatioTTM &&
    !grossProfitMarginTTM &&
    !netProfitMarginTTM &&
    !returnOnEquityTTM &&
    !totalDebtToCapitalizationTTM &&
    !interestCoverageTTM &&
    !symbol &&
    stockSymbol
  ) {
    return (
      <div className="flex justify-center items-center h-full">
        <Spinner color="primary" />
      </div>
    );
  }

  if (
    !isLoading &&
    !peRatioTTM &&
    !grossProfitMarginTTM &&
    !netProfitMarginTTM &&
    !returnOnEquityTTM &&
    !totalDebtToCapitalizationTTM &&
    !interestCoverageTTM
  ) {
    return (
      <div className="flex justify-center items-center h-full">
        Not available for this company.
      </div>
    );
  }

  return (
    <div>
      {/* Repeat the following structure for each line as needed */}
      <div className="font-bold">{symbol}</div>
      <div className="flex mt-3  items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">{peRatioTTM}</div>
      </div>
      <div className="text-left font-semibold text-sm">PE ratio TTM:</div>

      <div className="flex mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">{grossProfitMarginTTM}</div>
      </div>
      <div className="text-left font-semibold  text-sm">
        Gross Profit Margin TTM:
      </div>

      <div className="flex mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">{netProfitMarginTTM}</div>
      </div>
      <div className="text-left font-semibold text-sm">
        Net Profit Margin TTM:
      </div>

      <div className="flex mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">{returnOnEquityTTM}</div>
      </div>
      <div className="text-left font-semibold  text-sm">
        Return on Equity TTM:
      </div>

      <div className="flex  mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">{totalDebtToCapitalizationTTM}</div>
      </div>
      <div className="text-left mb-3  font-semibold  text-sm">
        Total Debt To Capitaliztion TTM:
      </div>
      <div className="flex  mt-3 items-center h-3">
        <div className="flex-1 bg-company-profile rounded-full h-full"></div>
        <div className="ml-2 text-md">{interestCoverageTTM}</div>
      </div>
      <div className="text-left mb-3  font-semibold text-sm">
        Interest Coverage TTM:
      </div>
    </div>
  );
}
